module.exports = __webpack_public_path__ + "assets/images/slope-babies/desktop.svg?v=2de4fc19";